var notifications = {
    init: function() {
        $('body').on('click', '.close-notification', function(e) {
            e.preventDefault();
            var that = $(this);
            if (that.hasClass('fadeOut')) {
                that.parent().fadeOut();
            } else {
                that.parent().slideUp();
            }
        });
    }
};